import { TextSkeleton } from '@components/common'

const AssetStatusLoading: React.FC = () => {
  return <TextSkeleton width="100%" height="var(--scale650)" />
}

export default AssetStatusLoading
